module.exports = __webpack_public_path__ + "img/icon-contact.dcd3e5ac.svg";